import formatter from '../../common/helpers/formatter';
import { Client } from '../../common/types/client';
import { DecryptedItem } from '../../common/types/items';
import { createDndCaseId, createFhbfCaseId, createFhbfTotalNumber } from '../../common/helpers/createCaseIds';

const reactAppVersion = process.env.REACT_APP_VERSION;

export const initClient = (clients: DecryptedItem<Client>[], location: string) => {
  if (reactAppVersion === 'dnd') {
    const caseId = createDndCaseId(clients);

    return {
      caseId,
      firstContactDate: formatter.formatIsoDate(new Date().toString()),
      date: formatter.formatIsoDate(new Date().toString()),
    };
  }

  if (reactAppVersion === 'fhbf' && location.includes('fachberatungsstelle')) {
    const caseId = createFhbfCaseId('BS', clients);

    return {
      caseId,
      firstContactDate: formatter.formatIsoDate(new Date().toString()),
      date: formatter.formatIsoDate(new Date().toString()),
      location: 'fuerth',
      policeStation: 'fuerth',
      targetGroup: ['female'],
      namedViolence: ['psychisch'],
      domesticViolence: true,
    };
  }

  if (reactAppVersion === 'fhbf' && location.includes('interventionsstelle')) {
    const caseId = createFhbfCaseId('ISTE', clients);
    const totalNumber = createFhbfTotalNumber(clients);

    return {
      caseId,
      totalNumber,
      firstContactDate: formatter.formatIsoDate(new Date().toString()),
      date: formatter.formatIsoDate(new Date().toString()),
      domesticViolence: true,
    };
  }

  return {
    firstContactDate: formatter.formatIsoDate(new Date().toString()),
    date: formatter.formatIsoDate(new Date().toString()),
  };
};
